import React from 'react';
import {Form, Input, Modal, Space} from 'antd';
import {MaskedInput} from 'antd-mask-input';
import cn from 'classnames';

import {Card} from '../../../components/Card/Card';
import {T2Button} from '../../../components/T2Button/T2Button';
import {OFFER_ITK, OFFER_POLICY, OFFER_T2} from '../../../config/routes';
import {phoneRegex} from '../../../shared/helpers/regex';

import img_phone from './img_phone.png'

import cls from './Connect.module.scss'

interface IForm {
    phone: string;
    email: string;
}

export const Connect = () => {

    const [open, setOpen] = React.useState(false);

    const onFinish = (data:IForm) => {
        console.log('onFinish', data);
        setOpen(true);
    }

    return (
        <div className={cls.cards}>
            <Card color={'gray'} className={cls.formWrapper} id={'connect'}>
                <div className={cls.wrapper}>
                    <h2>Подключите услугу</h2>
                    <Form size={'large'} validateTrigger={'onFinish'} onFinish={onFinish}>
                        <Form.Item name={'phone'} rules={[
                            {required: true, message: 'Пожалуйста заполните'},
                            {pattern: phoneRegex, message: 'Нужно заполнить полностью'}
                        ]}>
                            <MaskedInput mask={'+7 (000) 000-00-00'} placeholder={'Номер телефона'} className={cls.input}/>
                        </Form.Item>
                        <Form.Item name={'email'} rules={[
                            {required: true, message: 'Пожалуйста заполните'},
                            {type: 'email', message: 'Не соответствует формату email'}
                        ]}>
                            <Input placeholder={'Email'} className={cls.input}/>
                        </Form.Item>
                        <div className={cls.control}>
                            <T2Button htmlType={'submit'} className={cls.button}>Подключить</T2Button>
                            <div className={cls.price}>15 ₽/сут</div>
                        </div>
                    </Form>
                    <div className={'caption'}>
                        Для подключения услуги введите код из&nbsp;SMS с&nbsp;номера 312, который мы&nbsp;направим на&nbsp;ваш номер телефона.
                        Нажимая на&nbsp;кнопку &laquo;Подключить&raquo;, вы&nbsp;принимаете условия оферты <a href={OFFER_ITK}>ООО &laquo;ИТ&nbsp;Консул&raquo;</a>, <a href={OFFER_T2}>Оферта&nbsp;t2</a>&nbsp;и&nbsp;соглашаетесь на&nbsp;<a href={OFFER_POLICY}>Обработку персональных данных</a>.
                    </div>
                </div>
            </Card>
            <div className={cls.imageWrapper} style={{backgroundImage:`url(${img_phone})`}}/>

            <Modal open={open} onCancel={() => setOpen(false)} footer={null}>
                <Space direction={'vertical'} size={24}>
                <h2>Подтверждение</h2>
                <Form>
                    <div className={cls.codeForm}>
                    <Form.Item name={'code'} className={cls.item}>
                        <Input placeholder={'Код из SMS'} className={cls.code}/>
                    </Form.Item>
                    <Form.Item className={cls.item}>
                        <T2Button htmlType={'submit'} className={cls.button}>Подключить</T2Button>
                    </Form.Item>
                    </div>
                </Form>
                <div className={cn(['caption', cls.legal])}>
                    Нажимая на&nbsp;кнопку &laquo;Подключить&raquo;, вы&nbsp;принимаете условия оферты <a href={OFFER_ITK}>ООО &laquo;ИТ&nbsp;Консул&raquo;</a>, <a href={OFFER_T2}>Оферта&nbsp;t2</a>&nbsp;и&nbsp;соглашаетесь на&nbsp;<a href={OFFER_POLICY}>Обработку персональных данных</a>.
                </div>
                </Space>
            </Modal>

        </div>
    )
}